module.exports = __webpack_public_path__ + "static/media/finder.c488e871.svg";